import { Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import { colors } from 'constants/theme'

export interface SectionHeaderProps {
  label: string
  caption?: ReactNode
  trailing?: ReactNode
}

// Executive-board section bookmark — 22px label with a 3px navy left bar
// that anchors the heading and gives each section a "chapter break" feel
// when scanning the page top-to-bottom.
export default function SectionHeader({ label, caption, trailing }: SectionHeaderProps) {
  return (
    <Box className="hideInPrint" sx={{ mt: 1, mb: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 2 }}>
        <Box
          sx={{
            display: 'inline-flex',
            flexDirection: 'column',
            // Navy bookmark on the left edge — pulls the heading visually
            // forward without competing with the card content below.
            borderLeft: `3px solid ${colors.themeMainColor}`,
            pl: 1.25,
          }}
        >
          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 600,
              color: colors.textPrimary,
              lineHeight: 1.25,
              letterSpacing: 0.1,
            }}
          >
            {label}
          </Typography>
          {caption && (
            <Typography
              variant="caption"
              sx={{ color: colors.textLightGray, mt: 0.25, fontSize: 13 }}
            >
              {caption}
            </Typography>
          )}
        </Box>
        {trailing && <Box sx={{ flexShrink: 0 }}>{trailing}</Box>}
      </Box>
    </Box>
  )
}
